module.exports = __webpack_public_path__ + "static/img/code.68235a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/publicService/enterpriseDia/code.jpg
// module id = ezbg
// module chunks = 2